import { AppState } from './types';

export const localState = (state: AppState): AppState => state;
